var _defs, _rect, _rect2, _rect3, _rect4, _circle, _polygon, _polygon2, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPas7Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Object",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1122 1122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke: #323a89;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 43.94px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #323a89;\r\n      }\r\n\r\n      .cls-3, .cls-4 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: #30378b;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 187,
    y: 98.91,
    width: 741.45,
    height: 994.09,
    rx: 3.83,
    ry: 3.83
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 329.8,
    y: 312.3,
    width: 456.67,
    height: 63.74
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 329.8,
    y: 460.59,
    width: 307.56,
    height: 63.74
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 604.41,
    y: 856.03,
    width: 258.13,
    height: 63.74
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 414.93,
    cy: 738.75,
    r: 90.62
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "305.11 1000.61 294.14 954.67 239.57 962.77 331.41 803.7 396.95 841.54 305.11 1000.61"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "572.84 969.14 528.86 951.93 504.37 1001.37 426.16 835.17 494.64 802.95 572.84 969.14"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 373.74,
    y: 33,
    width: 378.96,
    height: 131.81,
    rx: 1.33,
    ry: 1.33
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPas7Icon);
export default __webpack_public_path__ + "static/media/pas7Icon.8abb51ad22829852be9bf8a2c21d7f2b.svg";
export { ForwardRef as ReactComponent };